import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cuan-label',
  templateUrl: './cuan-label.component.html',
  styleUrls: ['./cuan-label.component.scss']
})
export class CuanLabelComponent implements OnInit {

  @Input() data: any;
  @Input() isParsed = true;
  @Input() noSymbol: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }
  sign(n) {
    return Math.sign(n);
  }
}
